var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.$route.meta.headerShow)?_c('Header'):_vm._e(),(!_vm.$route.meta.headerShow)?_c('HeaderSecond'):_vm._e(),_c('router-view'),_c('Footer'),_c('GoTop'),(_vm.showHomePopup)?_c('HomePopup',{on:{"close":function($event){_vm.showHomePopup = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }